import React from 'react'
import { StackedProgressBar } from 'components/controls/progress-bar'

import 'less/crowd-progress.less'

const parseProgressSections = (requested, scheduled, completed) =>
  [['completed', completed], ['scheduled', scheduled]].map(
    ([className, metric]) => ({percentage: (metric / requested) * 100, className})
  )

const CrowdProgressBar = ({
  className,
  requested = 0,
  scheduled = 0,
  completed = 0,
}) =>
  <div className={`crowd-progress-status ${className}`}>
    <div className="progress-labels">
      <div className="progress-label-container"><div className="count">{completed}</div><span className="type">Completed</span></div>
      <div className="progress-label-container"><div className="count">{scheduled}</div><span className="type">Scheduled</span></div>
      <div className="progress-label-container"><div className="count">{requested}</div><span className="type">Requested</span></div>
    </div>
    <StackedProgressBar sections={parseProgressSections(requested, scheduled, completed)} />
  </div>

export default CrowdProgressBar
